import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ConfirmCodeState {
  code: string | null;
}

const initialState: ConfirmCodeState = { code: null };

const confirmCodeSlice = createSlice({
  name: "confirmCode",
  initialState,
  reducers: {
    setConfirmCode: (state, action: PayloadAction<string>) => {
      state.code = action.payload;
    },
    clearConfirmCode: (state) => {
      state.code = null;
    },
  },
});

export const { setConfirmCode, clearConfirmCode } = confirmCodeSlice.actions;
export default confirmCodeSlice.reducer;
